import React from "react";

import { BusMapData } from "../../types/app.types";

interface BusLayoutInfoProps {
  data: BusMapData;
  isFixedSeating: boolean;
}

export const BusLayoutInfo: React.FC<BusLayoutInfoProps> = ({
  data,
  isFixedSeating,
}) => {
  return (
    <div className="bus-layout-info">
      <div className="layout-details">
        <span className="layout-icon">{isFixedSeating ? "🎫" : "🚌"}</span>
        <div className="layout-text">
          <strong>Тип розсадки:</strong>
          {isFixedSeating ? " Фіксована" : " Вільна"}
        </div>
        <div className="layout-legend">
          <span className="layout-details">
            🔴 Загальна к-сть місць - {data.statistics.totalSeats}
          </span>
          <span className="layout-details">
            🟢 Макс. к-сть вільних місць -{" "}
            {data.maxDensityStats
              ? data.statistics.totalSeats -
                data.maxDensityStats.minSeatsRequired
              : data.statistics.availableSeats}
          </span>
          {isFixedSeating && (
            <span className="layout-details">
              🟡 Вільних місць - {data.statistics.availableSeats}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
